import React from "react";
import DataTable from "examples/Tables/DataTable";
import ordersDetailsTableData from "./data/orders_details";

export default function OrdersDetailsTable({ items }) {
  const tableData = ordersDetailsTableData(items);
  return (
    <DataTable
      table={tableData}
      entriesPerPage={false}
      canSearch={false}
      showTotalEntries={false}
      isSorted={false}
      pagination={true}
      noEndBorder
    />
  );
}
